import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { FileDataState } from '@/types/data.type';

type LibraryFileQueueContextType = {
    fileMap: Record<string, File>;
    fileStateMap: Record<string, FileDataState>;
    setFileMap: Dispatch<SetStateAction<Record<string, File>>>;
    setFileStateMap: Dispatch<SetStateAction<Record<string, FileDataState>>>;
};

const LibraryFileQueueContext = createContext<LibraryFileQueueContextType>({
    fileMap: {},
    fileStateMap: {},
    setFileMap: () => {},
    setFileStateMap: () => {},
});

export const useLibraryFileQueue = () => useContext(LibraryFileQueueContext);

export { LibraryFileQueueContext };
